import { ComplexEntityTypes, EntityTypeToDisplayName } from "./constants";

export const isComplexEntityType = (type) => {
  return Object.values(ComplexEntityTypes).includes(type);
};

export const calculateToolsPerformance = (controls) => {
  let toolsPerformance = {};
  controls.forEach((control) => {
    let tool = control.tool;
    if (toolsPerformance[tool]) {
      toolsPerformance[tool].all += 1;
      // Resolved is everything except a Gap.
      if (!control.is_gap || control.is_excluded || control.is_snoozed) {
        toolsPerformance[tool].resolved += 1;
      }
    } else {
      toolsPerformance[tool] = {
        all: 1,
        // Resolved is everything except a Gap.
        resolved:
          !control.is_gap || control.is_excluded || control.is_snoozed ? 1 : 0,
      };
    }
    if (control.severity === 3 && control.is_gap) {
      toolsPerformance[tool].severity = "High";
    }
  });
  return toolsPerformance;
};

export const getEntityTypeAndUniqueIdFromEntityId = (entityId) => {
  if (!entityId) return ["", ""];
  const dashIndex = entityId.indexOf("-");
  if (dashIndex === -1) return [entityId, ""];
  const entityType = entityId.substring(0, dashIndex);
  const uniqueId = entityId.substring(dashIndex + 1);
  return [entityType, uniqueId];
};

export const getEntityTypeFromEntityId = (entityId) => {
  const [entityType] = getEntityTypeAndUniqueIdFromEntityId(entityId);
  return entityType;
};

export const getSimpleEntityDisplayNameFromId = (entityId) => {
  const [, uniqueId] = getEntityTypeAndUniqueIdFromEntityId(entityId);
  return uniqueId;
};

export const isLocalhost = () => {
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  );
};

export const buildLinkToGap = (gapID) => {
  const domain = window.location.href.split("/")[2];
  return `${domain}/posture/controls?control_id=${gapID}`;
};

export const buildLinkToVulnerability = (vulnerabilityId) => {
  const domain = window.location.href.split("/")[2];
  return `${domain}/posture/vulnerabilities?cve=${vulnerabilityId}`;
};

export const getEntityTypeDisplayName = (entityType) => {
  return (
    EntityTypeToDisplayName[entityType] ||
    entityType
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  );
};

export const isEmailValid = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const isUrlValid = (url) => {
  return /^https:\/\/[^\s/$.?#].[^\s]*$/.test(url);
};

export const isValidGUID = (str) => {
  const guidRegex =
    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return guidRegex.test(str);
};

export const canonicalizeEmail = (email) => {
  // trim leading and trailing whitespace and convert to lowercase
  email = email.trim().toLowerCase();
  // split the email into local and domain parts, handling the case where there is no domain part
  const local_part = email.split("@")[0].replace(/[+.]/g, "");

  const domain_part = email.split("@")[1];
  // remove plus tag and periods from local part
  const canonical_email = `${local_part}@${domain_part}`;

  return canonical_email;
};

// Utility function for deep equality comparison
export const deepEqual = (a, b) => {
  if (a === b) return true;

  if (a == null || b == null) return a === b;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) return false;
    }
    return true;
  }

  if (typeof a === "object" && typeof b === "object") {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
      if (!keysB.includes(key)) return false;
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  }

  return false;
};

export const getHomePath = () => {
  const currentPath = window.location.pathname;
  return currentPath === "/" ? "/posture/controls" : "/";
};

export const navigateHome = () => {
  window.location.href = getHomePath();
};
